/**
 * en-GB messages added by Phase 4 task S52 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s52EnGB = {
    'dp.error.code_invalid': 'That code is not right, or it has expired. Check it and try again, or start again.',
    'dp.error.self_service_off': 'Data requests are not available online for this organisation.',
    'dp.error.subject_required': 'Choose the records that belong to this person before approving.',
    'dp.error.request_not_open': 'This request has already been decided.',
    'dp.error.contact_required': 'An email address is needed for this kind of request.',
    'dp.error.template_builtin': 'The standard refusal reasons cannot be deleted.',
    'dp.error.kind_not_offered': 'This kind of request is not offered.',
    'dp.keep.request_pending': 'Requests still being handled keep their details until they are finished.',
    'dp.keep.request_outcome': 'The outcome of the request is kept as evidence.',
    'dp.retention.requests': 'Finished data requests',
    'dp.requests.section.title': 'Data requests',
    'dp.request.kind.access': 'Copy of my data',
    'dp.request.kind.rectification': 'Correct my data',
    'dp.request.kind.erasure': 'Erase my data',
    'dp.request.kind.stop_marketing': 'Stop feedback emails',
    'dp.template.health_safety.title': 'Health and safety records kept',
    'dp.template.health_safety.text': 'We are required to keep health and safety records, such as who was on site, for 12 months. We will remove your details when that period ends.',
    'dp.template.legal_claim.title': 'Needed for a legal claim',
    'dp.template.legal_claim.text': 'We need to keep this information to establish, bring or defend a legal claim.',
    'dp.template.not_found.title': 'No record found',
    'dp.template.not_found.text': 'We could not find any record that matches the details you gave, so there is nothing for us to act on.',
    'dp.email.code.subject': 'Your code: {code}',
    'dp.email.code.body': 'Hello {name}, your code for your data request to {tenant} is {code}. It works for 10 minutes. If you did not ask for this, you can ignore this email.',
    'dp.email.received.subject': 'We have your request ({reference})',
    'dp.email.received.body': 'Hello {name}, we have received your request "{kind}" to {tenant}. Your reference is {reference}. We will answer by {due}. You can follow progress here: {link}',
    'dp.email.completed.subject': 'Your request is complete ({reference})',
    'dp.email.completed.body': 'Hello {name}, your request "{kind}" to {tenant} is complete. Details are here: {link}',
    'dp.email.completed.download': 'Your data can be downloaded for a limited time here: {download}',
    'dp.email.refused.subject': 'About your request ({reference})',
    'dp.email.refused.body': 'Hello {name}, we are not able to carry out your request "{kind}" to {tenant}. The reason: {reason}. Details are here: {link}',
    'dp.email.handler.received.subject': 'New data request {reference}',
    'dp.email.handler.received.body': 'A data request ({kind}, {reference}) has been received and is due by {due}. Open it in the portal under Data protection.',
    'dp.email.handler.due.subject': 'Data request {reference} is due soon',
    'dp.email.handler.due.body': 'Data request {reference} ({kind}) is due by {due}: {days} days left.',
    'dp.report.title': 'Data requests report',
    'dp.report.received': 'Received',
    'dp.report.on_time': 'Completed on time',
    'dp.report.late': 'Completed late',
    'dp.report.refused': 'Refused',
    'dp.report.open': 'Still open',
    'dp.report.by_kind': 'By kind',
    'dp.report.reasons': 'Refusal reasons',
    'dp.report.other_reason': 'Other reason',
    'dp.report.period': 'Period',
};
//# sourceMappingURL=s52.js.map